import styled from 'styled-components'

import { DeprecatedText } from '@syconium/little-miss-figgy'

import { NextDialogHeader } from '../../../../dialogs/NextDialog.client'

export const Instructions = styled(DeprecatedText)`
  margin: 16px 0 0;
`

export const Divider = styled.hr`
  border-width: 1px 0 0;
  border-color: ${o => o.theme.color.deprecated.stoneLight};
  border-style: solid;
  margin: 20px 0;
`

export const ProductTitle = styled(DeprecatedText)`
  margin-bottom: 20px;
`

export const WaitlistHeader = styled(NextDialogHeader)`
  padding: 0;
  padding-bottom: ${o => o.theme.spacing(2)};
`
